import { View, Text, TouchableOpacity } from "react-native";
import React from "react";
import MyText from "../custom/MyText";
import { gray } from "../../colors";

export default function SectionButton(props) {
  const Icon = props.icon;
  return (
    <TouchableOpacity
      onPress={props.onPress}
      style={[
        {
          marginTop: 10,
          paddingVertical: 10,
          marginHorizontal: 5,
          flexDirection: "row",
          borderBottomWidth: 2,
          borderBottomColor: "#C7C4C4",
          alignItems: "center",
        },
        props.style,
      ]}
    >
      <View
        style={[
          {
            width: 35,
            height: 35,
            borderRadius: 20,
            justifyContent: "center",
            alignItems: "center",
            borderWidth: 1,
            borderColor: "#C7C4C4",
          },
          props.iconPlaceStyle,
        ]}
      >
        {props.icon !== undefined && <Icon />}
      </View>
      <MyText style={[{ marginHorizontal: 10, color: gray }, props.textStyle]}>
        {props.name}
      </MyText>
    </TouchableOpacity>
  );
}
